var map = {
	"./TRM-labs.svg": "bfd7",
	"./alchemy.svg": "31ca",
	"./fathom-analytics.svg": "2c32",
	"./google-analytics.svg": "4e6f",
	"./infura.svg": "e2486",
	"./sentry.svg": "89d9",
	"./the-graph.svg": "c344"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "366a";